import iCaret from "../../../../assets/icons/caret-down-2.svg";
import { ReactNode, useState } from "react";
import "./accordion-item-secondary.sass";

type Props = {
  children: ReactNode;
  title: string;
};

const AccordionItemSecondary = ({ title, children }: Props) => {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div className="accordion-item-secondary">
      <div className="accordion-item-secondary__upper" onClick={handleOpen}>
        <div className="accordion-item-secondary__title">{title}</div>

        <img
          src={iCaret}
          className={`accordion-item-secondary__caret ${
            isOpen ? "accordion-item-secondary__caret--open" : ""
          }`}
          alt=""
        />
      </div>

      <div
        className={`accordion-item-secondary__content accordion-item-secondary__content${
          isOpen ? "--open" : "--closed"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default AccordionItemSecondary;
